<template lang="pug">
    #lista-pssc
        BaseHeader(
            :titulo="$t('mensagens.pssc.telaLista.titulo')",
            :btnTexto="$t('mensagens.pssc.telaLista.botaoCadastro')",
            :exibeBotao='!mostrar_lista_vazia'
            @btnHeaderClicado="incluirTerritorio"
        )
            div(v-if="!mostrar_lista_vazia" slot="direita" style="display:flex; align-items:center; justify-content: flex-end; gap:10px; width: 450px")
                div {{ $t('mensagens.pssc.telaLista.selectLote') }}
                el-select(
                    v-model='payload.filtros.payload.lotes',
                    filterable, multiple, value-key='id',
                    popper-class="custom-header"
                    :placeholder="$t('mensagens.pssc.telaLista.filtros.labelLotes')"
                    @change="fetchLista(0); fetchTotalizador()"
                    collapse-tags
                    style="min-width: 250px"
                )
                    template(id='header')
                        el-checkbox(
                            v-model="selecionar_todas_carteiras"
                            :indeterminate="selecionar_todas_carteiras_indeterminado"
                            @change="selecionarTodasCarteiras"
                        )
                            | Selecionar tudo
                    el-option(
                        v-for='(lote, index) in lotes',
                        :key='index',
                        :label='lote.nome',
                        :value='lote.id'
                        style="max-width: 250px"
                    ) {{ lote.nome }}

        .view-container-base-header
            section.lista-pssc__lista-vazia(v-if="mostrar_lista_vazia")
                div.lista-pssc__lista-vazia__content
                    img(src="@/assets/lyra-icons/pssc/gestao-lotes-lista-vazia.svg", height="121px", width="200px")
                    div.lista-pssc__lista-vazia__content__titulo
                        | {{ $t('mensagens.pssc.telaLista.listaVazia.titulo') }}
                    div.lista-pssc__lista-vazia__content__subtitulo
                        | {{ $t('mensagens.pssc.telaLista.listaVazia.subtitulo') }}
                    el-button(type='primary', @click='incluirTerritorio')
                        | {{ $t('mensagens.pssc.telaLista.listaVazia.botaoIncluirTerritorio') }}

            section.gestao-lote__container(v-else)
                section.lista-pssc__barra-pesquisa-filtro
                    .pesquisa-inteligente__content
                        .lista-pssc__barra-pesquisa-filtro__barra
                            i.el-icon-search
                            input.lista-pssc__barra-pesquisa__input(
                                v-model='payload.filtros.payload.texto',
                                type='text',
                                :placeholder="$t('mensagens.pssc.pesquisaInteligente.pesquisaInteligentePlaceholder')",
                                autocomplete='off',
                                @keyup.enter='fetchLista(0); fetchTotalizador()',
                                @input='pesquisaInteligente()'
                            )
                            el-button.primary-button.button-search.btn-filtro(
                                icon='el-icon-search',
                                type='primary',
                                size='large',
                                @click='fetchLista(0)',
                            ) {{ $t('mensagens.pssc.pesquisaInteligente.botaoBuscar') }}
                        transition(name='el-zoom-in-top')
                            ul.pesquisa-inteligente__ul(
                                v-show='mostrarLista',
                                v-loading='loadingPesquisaInteligente'
                            )
                                .mb-2.pesquisa-inteligente__lista-vazia(
                                    v-if='sugestoesBusca.length === 0'
                                ) {{ $t('mensagens.pssc.pesquisaInteligente.nenhumResultadoEncontrado') }}
                                .pesquisa-inteligente__lista(v-else)
                                    .mb-2.pesquisa-inteligente__car(v-for='opcao in sugestoesBusca')
                                        .pesquisa-inteligente__categoria
                                            span(
                                                v-if='opcao.resultados.length'
                                            ) {{ internacionalizacaoCategoria(opcao.categoria) }}

                                        li.pesquisa-inteligente__item(
                                            v-for='resultado in opcao.resultados',
                                            @click='selecionarOpcao(resultado.codigo || resultado.nome)'
                                        )
                                            span() {{ resultado.codigo || resultado.nome }}

                    .lista-pssc__barra-pesquisa-filtro__filtro
                        el-popover(placement='bottom', width='500', trigger='click')
                            el-button.button-outline.btn-filtro(
                                icon='lyra-icon lyra-filtro',
                                name='filtro',
                                slot='reference'
                            ) {{ $t('mensagens.pssc.telaLista.botaoFiltro') }}

                            div.mb-2(style="display: flex; justify-content: space-between; align-items: center")
                                #titulo-filtro
                                    | {{ $t('mensagens.pssc.telaLista.botaoFiltro') }}
                                #titulo-filtro-link(@click='fetchLista(0); fetchTotalizador()')
                                    | {{ $t('mensagens.pssc.telaLista.botaoAplicarFiltro') }}

                            el-collapse.lista-pssc__barra-pesquisa-filtro__filtro-popover-collapse(
                                v-model='payload.filtros.collapseAtivo',
                                accordion,
                                @change='abrirCollapse'
                            )
                                el-collapse-item(
                                    :title='$t("mensagens.pssc.telaLista.filtros.localidade")',
                                    name='estados'
                                )
                                    section(style="display: flex; justify-content: start")
                                        div.mr-3(v-loading='!estados.length')
                                            el-select(
                                                v-model='payload.filtros.payload.estado',
                                                filterable,
                                                clearable,
                                                value-key='id',
                                                @change="buscarMunicipios(); payload.filtros.payload.municipio = null"
                                                :placeholder='$t("mensagens.blocoFiltros.uteis.uf")'
                                            )
                                                el-option(
                                                    v-for='(estado, index) in estados',
                                                    :key='index',
                                                    :label='estado.nome',
                                                    :value='estado.id'
                                                ) {{ estado.nome }}
                                        div
                                            el-select(
                                                v-model='payload.filtros.payload.municipio',
                                                filterable,
                                                clearable,
                                                value-key='id',
                                                :placeholder='$t("mensagens.blocoFiltros.uteis.municipio")',
                                                :disabled='!payload.filtros.payload.estado'
                                            )
                                                el-option(
                                                    v-for='(municipio, index) in municipios',
                                                    :key='index',
                                                    :label='municipio.nome',
                                                    :value='municipio.id'
                                                ) {{ municipio.nome }}
                                el-collapse-item(
                                    :title='$t("mensagens.pssc.telaLista.filtros.restricoes")',
                                    name='restricoes'
                                )
                                    el-checkbox-group(
                                        v-model='payload.filtros.payload.restricoes',
                                        :max='2'
                                    )
                                        el-checkbox(label='INCONFORME')
                                            | {{ $t('mensagens.pssc.telaLista.filtros.restricoesDiagSocio') }}
                                        el-checkbox(label='POSSIVEL_INCONSISTENCIA')
                                            | {{ $t('mensagens.pssc.telaLista.filtros.restricoesAdeqCodFloBr') }}
                                el-collapse-item(
                                    :title='$t("mensagens.pssc.telaLista.filtros.statusEnvioTrilha")',
                                    name='statusEnvioTrilha'
                                )
                                    el-checkbox-group(v-model='payload.filtros.payload.statusEnvioTrilha')
                                        el-checkbox(label='ENVIADO')
                                            | {{ $t('mensagens.pssc.telaLista.filtros.statusEnvioTrilhaEnviado') }}
                                        el-checkbox(label='ERRO_CONTATO')
                                            | {{ $t('mensagens.pssc.telaLista.filtros.statusEnvioTrilhaErroContato') }}
                                        el-checkbox(label='ERRO_ENVIO')
                                            | {{ $t('mensagens.pssc.telaLista.filtros.statusEnvioTrilhaErroEnvio') }}
                                        el-checkbox(label='GERANDO_TRILHA')
                                            | {{ $t('mensagens.pssc.telaLista.filtros.statusEnvioTrilhaGerandoTrilha') }}
                                        el-checkbox(label='NA_FILA_ENVIO')
                                            | {{ $t('mensagens.pssc.telaLista.filtros.statusEnvioTrilhaNaFila') }}
                                        el-checkbox(label='VISUALIZADO')
                                            | {{ $t('mensagens.pssc.telaLista.filtros.statusVisualizado') }}

                section.lista-pssc__totalizadores
                    #titulo {{ $t('mensagens.pssc.telaLista.tituloTotalizadores') }}

                    .lista-pssc__totalizadores__cards
                        .lista-pssc__totalizadores__cards__card(v-loading="conditions.onFetching")
                            div(style='display: flex; align-items: center; width: 100%')
                                img(src="@/assets/lyra-icons/pssc/totalizador-imoveis.svg").mr-2
                                | {{ $t('mensagens.pssc.telaLista.cardTotalImoveis') }}
                            el-statistic(:value="payload.totalizadores.total_imoveis")

                        .lista-pssc__totalizadores__cards__card(v-loading="conditions.onFetching")
                            div(style='display: flex; align-items: center; width: 100%')
                                img(src="@/assets/lyra-icons/pssc/totalizador-conforme.svg").mr-2
                                | {{ $t('mensagens.pssc.telaLista.cardConforme') }}
                            el-statistic(:value="payload.totalizadores.conforme")

                        .lista-pssc__totalizadores__cards__card(v-loading="conditions.onFetching")
                            div(style='display: flex; align-items: center; width: 100%')
                                img(src="@/assets/lyra-icons/pssc/totalizador-inconforme.svg").mr-2
                                | {{ $t('mensagens.pssc.telaLista.cardInconforme') }}
                            el-statistic(:value="payload.totalizadores.inconforme")

                section.lista-pssc__lista
                    #titulo {{ $t('mensagens.pssc.telaLista.tituloLista') }}

                    .lista-pssc__lista__tabela
                        el-table(
                            :data='payload.itens',
                            stripe,
                            height='calc(100% - 40px)',
                            @sort-change='ordenar',
                            v-loading='conditions.onFetching',
                            :empty-text="$t('mensagens.pssc.telaLista.tabela.listaVazia')"
                        )
                            el-table-column(
                                :label='$t("mensagens.pssc.telaLista.tabela.labels.territorio")',
                                align='left',
                                sortable
                            )
                                template(slot-scope='scope')
                                    span {{ scope.row.territorio }}

                            el-table-column(
                                :label='$t("mensagens.pssc.telaLista.tabela.labels.situacao_car")',
                                align='left'
                            )
                                template(slot-scope='scope')
                                    el-tag(
                                        size="small", effect="plain",
                                        :style="identificarStyleTag(scope.row.status_situacao_car)"
                                    ) {{ $t(`mensagens.pssc.telaLista.tabela.enumsSituacoes.${scope.row.status_situacao_car}`) }}

                            el-table-column(
                                :label='$t("mensagens.pssc.telaLista.tabela.labels.condicao_car")',
                                align='left'
                            )
                                template(slot-scope='scope')
                                    el-tag(
                                        size="small", effect="plain",
                                        :style="identificarStyleTag(scope.row.status_condicao_car)"
                                    ) {{ $t(`mensagens.pssc.telaLista.tabela.enumsSituacoes.${scope.row.status_condicao_car}`) }}

                            el-table-column(
                                :label='$t("mensagens.pssc.telaLista.tabela.labels.diagnostico_socioambiental")',
                                align='left'
                            )
                                template(slot-scope='scope')
                                    el-tag(
                                        size="small", effect="plain",
                                        :style="identificarStyleTag(scope.row.status_diagnostico_socioambiental)"
                                    ) {{ $t(`mensagens.pssc.telaLista.tabela.enumsSituacoes.${scope.row.status_diagnostico_socioambiental}`) }}

                            el-table-column(
                                :label='$t("mensagens.pssc.telaLista.tabela.labels.verificacao_codigo_florestal_brasileiro")',
                                align='left'
                            )
                                template(slot-scope='scope')
                                    el-tag(
                                        size="small", effect="plain",
                                        :style="identificarStyleTag(scope.row.status_verificacao_cod_florestal_brasileiro)"
                                    ) {{ $t(`mensagens.pssc.telaLista.tabela.enumsSituacoes.${scope.row.status_verificacao_cod_florestal_brasileiro}`) }}

                            el-table-column(
                                :label='$t("mensagens.pssc.telaLista.tabela.labels.status_trilha")',
                                align='left'
                            )
                                template(slot-scope='scope')
                                    el-tag(
                                        size="small", effect="plain",
                                        :style="identificarStyleTag(scope.row.status_trilha)"
                                    ) {{ $t(`mensagens.pssc.telaLista.tabela.enumsSituacoes.${scope.row.status_trilha}`) }}

                            el-table-column(
                                :label='$t("mensagens.pssc.telaLista.tabela.labels.acoes")',
                                width='100', align='left'
                            )
                                template(slot-scope='scope')
                                    el-dropdown.action-button(trigger='click')
                                        span.el-dropdown-link
                                            i.mdi.mdi-dots-vertical.mudando-cursor
                                        el-dropdown-menu(slot='dropdown')
                                            el-dropdown-item(
                                                v-for='(acao, index) in scope.row.acoes_disponiveis',
                                                :key='index',
                                                :icon='acoes_disponiveis[acao].icone',
                                                @click.native='acoes_disponiveis[acao].callback(scope.row)'
                                            ) {{ $t(`mensagens.pssc.telaLista.tabela.acoes.${acoes_disponiveis[acao].codigo}`) }}

                        .lista-pssc__lista__tabela__rodape
                            div(style="display: flex; align-items: center; justify-content: space-between")
                                div.mr-4 {{ payload.paginacao.total }} {{ $t(`mensagens.pssc.telaLista.tabela.paginacaoResultado`) }}

                                | {{ $t(`mensagens.pssc.telaLista.tabela.paginacaoPorPagina`) }}
                                el-select(
                                    v-model='payload.paginacao.itensPorPagina',
                                    class="ml-2",
                                    style='width: 70px',
                                    size="mini"
                                    @change="fetchLista(0)"
                                )
                                    el-option(
                                        v-for='item in itensPorPagina',
                                        :key='item',
                                        :label='item',
                                        :value='item'
                                    )

                            .tabela-rodape--pagination
                                el-pagination(
                                    mini,
                                    layout='prev, pager, next, jumper',
                                    hide-on-single-page
                                    :page-size='payload.paginacao.itensPorPagina',
                                    :current-page.sync='payload.paginacao.pagina',
                                    :total='payload.paginacao.total',
                                    @current-change='proximaPagina'
                                )

                ModalEditarDadosContato(
                    :show='modalEditarDadosContato.mostrar',
                    :territorio='modalEditarDadosContato.territorio'
                    @closeDialog='modalEditarDadosContato.mostrar = false'
                )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import ModalEditarDadosContato from '@/components/pssc/ModalEditarDadosContatoPssc';
import PSSCService from '@/services/PSSCService';
import {identificarStyleTag} from '@/constants/ColorsUtilsPssc';

export default {
    name: 'PSSC',
    components: {BaseHeader, ModalEditarDadosContato},
    data() {
        return {
            conditions: {
                onFetching: false,
                onSaving: false
            },
            payload: {
                filtros: {
                    payload: {
                        texto: null,
                        estado: null,
                        municipio: null,
                        areaImovel: null,
                        areaPlantadaSoja: null,
                        situacaoCar: [],
                        restricoes: [],
                        statusEnvioTrilha: [],
                        lotes: []
                    },
                    collapseAtivo: [''],
                    situacoesCar: []
                },
                totalizadores: {
                    total_imoveis: 0,
                    inconforme: 0,
                    conforme: 0
                },
                itens: [],
                paginacao: {
                    direcao: null,
                    itensPorPagina: 10,
                    ordernarPor: null,
                    pagina: 0,
                    totalPaginas: 0,
                    total: 0
                }
            },
            selecionar_todas_carteiras: true,
            selecionar_todas_carteiras_indeterminado: false,
            itensPorPagina: [10, 20, 50, 100],
            mostrarLista: false,
            loadingPesquisaInteligente: false,
            sugestoesBusca: [],
            estados: [],
            municipios: [],
            lotes: [],
            mostrar_lista_vazia: true,
            modalEditarDadosContato: {
                mostrar: false,
                territorio: null
            },
            acoes_disponiveis: {
                VISUALIZAR_CAR: {
                    codigo: 'VISUALIZAR_CAR',
                    icone: 'el-icon-view',
                    callback: this.visualizarCar
                },
                VER_TRILHA: {
                    codigo: 'VER_TRILHA',
                    icone: 'el-icon-guide',
                    callback: this.visualizarTrilha
                },
                ENVIAR_TRILHA: {
                    codigo: 'ENVIAR_TRILHA',
                    icone: 'el-icon-s-promotion',
                    callback: this.enviarTrilha
                },
                EDITAR_DADOS_CONTATO: {
                    codigo: 'EDITAR_DADOS_CONTATO',
                    icone: 'el-icon-edit',
                    callback: this.editarContato
                }
            },
            acaoCollapse: {
                estados: {
                    collapse: 'estados',
                    callback: 'buscarEstados'
                }
            }
        };
    },
    watch: {
        'payload.filtros.payload.lotes'(val) {
            if (val.length === 0) {
                this.selecionar_todas_carteiras = false;
                this.selecionar_todas_carteiras_indeterminado = false;
            } else if (val.length === this.lotes.length) {
                this.selecionar_todas_carteiras = true;
                this.selecionar_todas_carteiras_indeterminado = false;
            } else {
                this.selecionar_todas_carteiras_indeterminado = true;
            }
        }
    },
    async mounted() {
        await this.fetchLista(0);
        if (this.payload.itens.length !== 0) {
            this.mostrar_lista_vazia = false;
        }
        await this.fetchTotalizador();
        await this.fetchLotes();
    },
    methods: {
        identificarStyleTag,
        async fetchLotes() {
            try {
                const {data} = await PSSCService.buscarLotes();
                this.lotes = data.itens;
                this.payload.filtros.payload.lotes = data.itens.map(item => item.id);
            } catch {
                this.$notify.error({
                    message: 'Não foi possível buscar lotes.'
                });
            }
        },
        async fetchTotalizador() {
            try {
                const {data} = await PSSCService.buscarTotalizadores(this.payload.filtros.payload);
                this.payload.totalizadores = data;
            } catch {
                this.$notify.error({
                    message: 'Não foi possível buscar lotes.'
                });
            }
        },
        async fetchLista(pagina) {
            this.mostrarLista = false;
            this.conditions.onFetching = true;

            const paginacao = {...this.payload.paginacao};
            paginacao.pagina = pagina;

            await PSSCService.buscarPorFiltro({
                ...this.payload.filtros.payload,
                paginacao: paginacao
            })
                .then(({data}) => {
                    this.payload.itens = data.itens;

                    this.payload.paginacao.total = data.paginacao.total;
                    this.payload.paginacao.itensPorPagina = data.paginacao.itensPorPagina;
                    this.payload.paginacao.totalPaginas = data.paginacao.totalPaginas;
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.erroSituacao')
                    });
                })
                .finally(() => {
                    this.conditions.onFetching = false;
                    const component = document.getElementsByClassName('el-pagination__jump')[0];
                    if (component) {
                        component.firstChild.textContent =
                            this.$t('mensagens.pssc.telaLista.tabela.irParaPagina');
                    }
                });
        },
        abrirCollapse(ref) {
            if (ref) {
                try {
                    if (ref !== 'estados') return;
                    const acao = this.acaoCollapse[ref];
                    if (!this[ref].length && typeof this[ref] !== 'string') {
                        this[acao.callback]();
                    }
                } catch (error) {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados.'
                    );
                    throw new Error(
                        'Ação não registrada para o collapse:' +
                        ref +
                        ', ERRRO:' +
                        error
                    );
                }
            }
        },
        proximaPagina(pagina) {
            this.fetchLista(pagina - 1);
        },
        ordenar(props) {
            this.payload.paginacao.direcao = props.order === 'ascending' ? 'ASC' : 'DESC';
            this.payload.paginacao.ordernarPor = props.column.label;

            if (props.order === null) this.payload.paginacao.ordernarPor = null;
            this.fetchLista(0);
        },
        exibirNotify(tipo, message) {
            this.$notify[tipo]({
                message
            });
        },
        buscarEstados() {
            PSSCService.buscarLocalidadeTerritoriosElegíveis({
                'gestaoLote': true,
                'idSuperior': 1,
                'nivel': 1
            })
                .then(({data}) => {
                    setTimeout(() => {
                        this.estados = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de estados.'
                    );
                    throw error;
                });
        },
        buscarMunicipios() {
            if (this.payload.filtros.payload.estado) {
                PSSCService.buscarLocalidadeTerritoriosElegíveis({
                    'gestaoLote': true,
                    'idSuperior': this.payload.filtros.payload.estado,
                    'nivel': 2
                })
                    .then(({data}) => {
                        this.municipios = null;
                        setTimeout(() => {
                            this.municipios = data;
                        }, 500);
                    })
                    .catch(error => {
                        this.exibirNotify(
                            'error',
                            'Não foi possível buscar os dados de municipio.'
                        );
                        throw error;
                    });
            }
        },
        selecionarTodasCarteiras(value) {
            if (value) {
                this.payload.filtros.payload.lotes = this.lotes.map(item => item.id);
                this.fetchLista(0);
                this.fetchTotalizador();
            } else {
                if (this.payload.filtros.payload.lotes.length !== this.lotes.length) {
                    this.fetchLista(0);
                    this.fetchTotalizador();
                }
                this.payload.filtros.payload.lotes = [];
            }
        },
        incluirTerritorio() {
            this.$router.push({name: 'IncluirTerritorioPSSC'});
        },
        editarContato(row) {
            this.modalEditarDadosContato.territorio = row.id;
            this.modalEditarDadosContato.mostrar = true;
        },
        enviarTrilha() {
            alert('Enviar trilha');
        },
        visualizarTrilha() {
            alert('Ver trilha');
        },
        visualizarCar(row) {
            if (this.$route.name !== 'TerritorioPssc') {
                this.$router.push({
                    name: 'TerritorioPssc',
                    params: {
                        territorio: row.id
                    }
                });
            } else {
                this.$router.go();
            }
        },
        async pesquisaInteligente() {
            if (this.payload.filtros.payload.texto.length >= 3) {
                this.loadingPesquisaInteligente = true;
                this.mostrarLista = true;
                await PSSCService.pesquisaInteligentePssc({
                    'texto': this.payload.filtros.payload.texto,
                    'gestaoLote': true
                })
                    .then(({data}) => {
                        if (data.cars.resultados.length === 0 && data.territorios.resultados.length === 0) {
                            this.sugestoesBusca = [];
                        } else {
                            this.sugestoesBusca = data;
                        }
                        this.loadingPesquisaInteligente = false;
                    })
                    .catch(error => {
                        this.exibirNotify(
                            'error',
                            'Não foi possível buscar os territórios a partir do termo informado.'
                        );
                        throw error;
                    });
            } else {
                this.mostrarLista = false;
                this.sugestoesBusca = [];
            }
        },
        selecionarOpcao(chave) {
            this.payload.filtros.payload.texto = chave;
            this.fetchLista(0);
        },
        internacionalizacaoCategoria(chave) {
            if (!chave) {
                return;
            }
            let chaveMaiuscula = chave.toUpperCase();
            chaveMaiuscula = chaveMaiuscula.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            chaveMaiuscula = chaveMaiuscula.replace(/\s+/g, '-');

            return this.$t(`mensagens.pssc.pesquisaInteligente.categorias.${chaveMaiuscula}`);
        }
    }
};
</script>

<style lang="scss">
#lista-pssc {
    height: 100%;
    width: 100%;
    .view-container-base-header {
        .gestao-lote__container {
            padding: 4px 4px 0 4px;
        }
    }

    .lista-pssc__lista-vazia {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        border-radius: 10px;

        .lista-pssc__lista-vazia__content {
            display: grid;
            justify-items: center;
            width: 500px;
            text-align: center;

            .lista-pssc__lista-vazia__content__titulo {
                font-size: 18px;
                font-weight: 500;
                margin-bottom: 15px;
            }

            .lista-pssc__lista-vazia__content__subtitulo {
                font-size: 14px;
                margin-bottom: 15px;
            }
        }
    }

    .lista-pssc__barra-pesquisa-filtro {
        display: grid;
        gap: 14px;
        grid-template-columns: calc(100% - 185px) 169px;
        height: 46px;
        margin-bottom: 20px;

        .lista-pssc__barra-pesquisa-filtro__barra {
            height: 46px;
            border-radius: 5px;
            color: var(--primary);
            background-color: var(--white);
            display: flex;
            justify-content: center;
            box-shadow: 0 1px 5px 0 var(--block-shadow);

            i.el-icon-search {
                color: var(--primary);
                font-size: 25px;
                font-weight: bold;
                display: flex;
                align-items: center;
                margin: 0 8px;
            }

            .el-button {
                width: fit-content;
                margin-right: 0px !important;
                display: flex;
                align-items: center;
                margin: 0 8px;
                .el-icon-search {
                    color: var(--white);
                    margin: 0;
                    font-size: 14px;
                }
            }
            .el-button:hover {
                color: var(--primary) !important;
                .el-icon-search {
                    color: var(--primary);
                }
            }
            .el-button:focus {
                color: var(--primary) !important;
                .el-icon-search {
                    color: var(--primary);
                }
            }

            .lista-pssc__barra-pesquisa__input {
                width: 100%;
                height: 100%;
                border: none;
                outline: none;
                border-radius: 5px;
                color: var(--primary);
            }
        }

        .lista-pssc__barra-pesquisa-filtro__filtro {
            height: 46px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            width: fit-content;
        }
        .btn-filtro {
            height: 46px !important;
        }
        .pesquisa-inteligente__ul {
            list-style: none;
            padding: 16px 0;
            position: relative !important;
            z-index: 42;
            margin-top: 16px;
            border-radius: 5px;
            background-color: var(--white);
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

            .pesquisa-inteligente__lista-vazia {
                color: #7C7C7C;
                padding-left: 41px;
            }

            .pesquisa-inteligente__lista {
                display: grid;
                grid-gap: 8px !important;

                .pesquisa-inteligente__car {
                    margin: 0 !important;

                    li {
                        padding-left: 18px;
                        margin-top: 5px;
                        cursor: pointer;
                    }
                    .pesquisa-inteligente__categoria {
                        font-weight: bold;
                        span {
                            padding: 0 16px;
                        }
                    }
                    .pesquisa-inteligente__item {
                        padding: 8px 0 7px 0;
                        margin-top: 0px !important;
                        span {
                            padding: 0 16px;
                        }
                    }
                    .pesquisa-inteligente__item:hover {
                        background-color: #DEF0B9;
                    }
                }
            }
        }
    }

    .lista-pssc__totalizadores {
        margin-bottom: 20px;

        .lista-pssc__totalizadores__cards {
            display: grid;
            gap: 15px;
            grid-template-columns: repeat(3, 1fr);

            .lista-pssc__totalizadores__cards__card {
                height: 70px;
                padding: 10px;
                background: white;
                border-radius: 5px;
                display: grid;
                grid-template-columns: 1fr 1fr;
                align-items: center;
                justify-items: center;
                font-size: 14px;
                font-weight: 500;
            }
        }
    }

    .lista-pssc__lista {

        .lista-pssc__lista__tabela {
            height: calc(100vh - 414px);
            background-color: var(--white);

            .el-table {
                border-radius: 5px;
                height: calc(100% - 40px);
                width: 100%;
            }

            .el-table th {
                font-weight: bold;
                font-size: 14px;
            }

            .tabela-btn {
                margin-top: 14px;
                display: flex;
                justify-content: start;
                align-items: center;
            }

            .lista-pssc__lista__tabela__rodape {
                height: 40px;
                padding: 0 10px;
                background: var(--white);
                display: grid;
                justify-items: start;
                align-items: center;
                grid-template-columns: 1fr 1fr;

                .tabela-rodape--pagination {
                    width: 100%;
                    display: flex;
                    justify-content: flex-end;

                    .el-pager li.active {
                        color: var(--white);
                        font-weight: 900;
                        background: var(--primary);
                    }

                    .el-pager li {
                        padding: 0 4px;
                        background: var(--white);
                        vertical-align: top;
                        display: inline-block;
                        font-size: 13px !important;
                        min-width: 28px !important;
                        height: 28px !important;
                        line-height: 28px !important;
                        box-sizing: border-box;
                        text-align: center;
                        margin: 0;
                        border-radius: 2px;
                        color: var(--primary);
                    }

                    .el-pagination button {
                        height: 28px;
                    }
                }
            }

            .box-expande-listagem {
                display: flex;
                align-items: flex-start;
                justify-content: space-around;
                margin-top: 15px;
                margin-bottom: 15px;
                padding: 0 18px;

                .box-expande-listagem-box {
                    width: 33%;

                    .box-expande-listagem-box-texto {
                        font-weight: 600;
                        color: var(--primary);
                    }

                    .box-expande-listagem-box-value {
                        max-height: 75px;
                        overflow-y: auto;
                        font-weight: 400;
                        color: var(--primary);
                    }
                }
            }
        }
    }

    #titulo {
        margin-bottom: 10px;
        margin-top: 10px;
        color: var(--black);
        font-weight: 500;
    }

    #total {
        font-weight: 500;
        font-size: 16px;
        text-align: end;
        width: 100%;
    }

    .lyra-icon::before {
        content: '';
        width: 24px;
        height: 25px;
        display: inline-block;
        background-color: var(--primary);
    }
}

#titulo-filtro {
    color: var(--primary);
    font-weight: 500;
    font-size: 16px;
    line-height: 14px;
}

#titulo-filtro-link {
    color: #1989fa;
    font-weight: 500;
    text-decoration: underline;
    cursor: pointer;
    font-size: 16px;
    line-height: 14px;
}

.lista-pssc__barra-pesquisa-filtro__filtro-popover-collapse {
    .el-select {
        width: 100%;
    }

    .el-collapse-item__header {
        font-weight: 500;
    }

    .filtro-accordion {
        margin-top: 10px;
    }

    .el-checkbox,
    .el-radio {
        margin-right: 12px !important;
        min-width: 200px;
        line-height: 2;
    }

    .el-radio {
        color: var(--primary);
        font-weight: 500;
        line-height: 16px;
    }
}

.custom-header {
    .el-checkbox {
        display: flex;
        padding: 10px 15px;
        align-items: center;
        margin-bottom: 0 !important;
        border-bottom: 1px solid rgba(102, 102, 102, 0.18);
    }
    .is-checked {
        background-color: #DEF0B9  !important;
    }

    .el-checkbox:hover {
        background-color: #DEF0B9 !important;
    }
}

.el-select-dropdown__item.hover {
    background: white !important;
}

.el-select-dropdown__item:hover {
    background: #DEF0B9 !important;
}

.el-select-dropdown__item.selected {
    background-color: #DEF0B9 !important;
}

.el-tag.el-tag--info {
    background-color: #EBF4EB !important;
    border-color: #EBF4EB !important;
    color: #359138 !important;
    max-width: 100px !important;
    max-height: 40px !important;

    .el-tag__close {
        color: white !important;
        background: #359138 !important;
    }
}

.base-button-container {
    display: flex !important;
    gap: 20px;
}

.el-statistic .con {
    justify-content: flex-end !important;
}
</style>
